import {apartment, commercial, flat, house, modularHouse} from "@pg-mono/string-utils";
import {OfferType} from "@pg-rp/common-types";

export const getOfferTypeName = (offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return "mieszkanie";
        case OfferType.HOUSE:
            return "dom";
        case OfferType.COMMERCIAL:
            return "lokal użytkowy";
        case OfferType.MODULAR_HOUSE:
            return "dom modułowy";
        default:
            throw new Error("Unknown offer type");
    }
};

export const getOfferTypeNameCapital = (offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return "Mieszkanie";
        case OfferType.HOUSE:
            return "Dom";
        case OfferType.COMMERCIAL:
            return "Lokal użytkowy";
        case OfferType.MODULAR_HOUSE:
            return "Dom modułowy";
        default:
            throw new Error("Unknown offer type");
    }
};

export const getOfferTypePluralize = (amount: number, offerType: number, isApartment = false) => {
    switch (Number(offerType)) {
        case OfferType.FLAT:
            return isApartment ? apartment.nominative(amount) : flat.nominative(amount);
        case OfferType.HOUSE:
            return house.nominative(amount);
        case OfferType.COMMERCIAL:
            return commercial.nominative(amount);
        case OfferType.MODULAR_HOUSE:
            return modularHouse.nominative(amount);
        default:
            return "";
    }
};

export const getNewOfferTypeNameCapital = (type: OfferType) => {
    switch (type) {
        case OfferType.FLAT:
            return "Nowe mieszkanie";
        case OfferType.HOUSE:
            return "Nowy dom";
        case OfferType.COMMERCIAL:
            return "Nowy lokal użytkowy";
        case OfferType.MODULAR_HOUSE:
            return "Nowy dom modułowy";
        default:
            return "Nowa nieruchomość";
    }
};
import {apartment, commercial, flat, house, modularHouse} from "@pg-mono/string-utils";
import {OfferType} from "@pg-rp/common-types";

export const getOfferTypeName = (offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return "mieszkanie";
        case OfferType.HOUSE:
            return "dom";
        case OfferType.COMMERCIAL:
            return "lokal użytkowy";
        case OfferType.MODULAR_HOUSE:
            return "dom modułowy";
        default:
            throw new Error("Unknown offer type");
    }
};

export const getOfferTypeNameCapital = (offerType: OfferType) => {
    switch (offerType) {
        case OfferType.FLAT:
            return "Mieszkanie";
        case OfferType.HOUSE:
            return "Dom";
        case OfferType.COMMERCIAL:
            return "Lokal użytkowy";
        case OfferType.MODULAR_HOUSE:
            return "Dom modułowy";
        default:
            throw new Error("Unknown offer type");
    }
};

export const getOfferTypePluralize = (amount: number, offerType: number, isApartment = false) => {
    switch (Number(offerType)) {
        case OfferType.FLAT:
            return isApartment ? apartment.nominative(amount) : flat.nominative(amount);
        case OfferType.HOUSE:
            return house.nominative(amount);
        case OfferType.COMMERCIAL:
            return commercial.nominative(amount);
        case OfferType.MODULAR_HOUSE:
            return modularHouse.nominative(amount);
        default:
            return "";
    }
};

export const getNewOfferTypeNameCapital = (type: OfferType) => {
    switch (type) {
        case OfferType.FLAT:
            return "Nowe mieszkanie";
        case OfferType.HOUSE:
            return "Nowy dom";
        case OfferType.COMMERCIAL:
            return "Nowy lokal użytkowy";
        case OfferType.MODULAR_HOUSE:
            return "Nowy dom modułowy";
        default:
            return "Nowa nieruchomość";
    }
};
